import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { MotArtCitizenship } from 'shell/models/mutation/mot-art-citizenship';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface ReasonCitizenshipProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
  required?: boolean;
}

const ReasonCitizenshipComponent = ({
  disabled,
  onChange,
  value,
  required,
  error,
  label = 'Motivo cittadinanza',
}: ReasonCitizenshipProps): React.ReactElement => {
  const [reasons] = useHttpFetch<HttpResponse<Array<MotArtCitizenship>>, Array<ItemVM>>(
    `${__PERSON_NEW_API_URL__}/leggi-sulla-cittadinanza/motivi`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: (response) => {
        return ((response?.data?.payload || []) as Array<MotArtCitizenship>).map((element) => {
          return {
            id: element?.key?.subEvento || '',
            value: element?.descrizione || '',
          };
        }) as Array<ItemVM>;
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="reason-citizenship-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="reason-citizenship-label"
        id="reason-citizenship"
        name="reason-citizenship"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {((reasons.data || []) as unknown as Array<ItemVM>)?.map((reason: ItemVM) => (
          <MenuItem key={reason.id} value={reason.id}>
            {reason.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ReasonCitizenshipComponent.displayName = 'Reason Citizenship list component';

const ReasonCitizenship = memo(ReasonCitizenshipComponent);

export default ReasonCitizenship as typeof ReasonCitizenshipComponent;
